import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Spinner from '../Spinner';

const SamlProtectedRoute = ({ component: Component, expiry, isAuthenticated, loading, ...rest }) => {
  if (loading) return <Spinner />;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated || expiry - Date.now() <= 0) {
          return <Redirect to={{ pathname: '/saml', state: { initialUrl: rest.path } }} />;
        } else {
          return <Component {...props} />;
        }
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  expiry: state.saml.expiry,
  isAuthenticated: state.saml.isAuthenticated,
  loading: state.saml.loading,
});

export default connect(mapStateToProps, null)(SamlProtectedRoute);
